import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => {
  const primary = light ? "text-white" : "text-navy";
  const sub = light ? "text-white/60" : "text-muted-foreground";
  return (
    <Link to="/" data-testid="brand-logo" className={`group flex items-center gap-3 ${className}`}>
      <span className="relative flex h-10 w-10 items-center justify-center rounded-md bg-brand">
        <svg viewBox="0 0 24 24" className="h-5 w-5 text-white" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-[15px] font-extrabold tracking-tight ${primary}`}>
          Global-Elect <span className="text-aero">Aviation</span>
        </span>
        <span className={`text-[10px] font-medium uppercase tracking-[0.18em] ${sub}`}>
          A division of G-EMC
        </span>
      </span>
    </Link>
  );
};
